const {UriBuilder} = require("uribuilder");
module.exports = (app) => app.controller('orderReceiptCreateController', /* @ngInject */ function ($scope, iframeConfig, $sce, $timeout) {
    $scope.init = init;
    $scope.$on('$destroy', handleDestroy);

    $scope.iframeId = 'orderReceiptCreateIframe';

    let iframeEl;

    /**
     * @type {string}
     */
    let orderNumber;

    function init(orderId, iframeId) {
        orderNumber = orderId;
        if (iframeId) {
            $scope.iframeId = iframeId;
        }
        // Warte auf DOM-Rendering, bevor wir auf das iframe-Element zugreifen
        $timeout(function() {
            initIframe();
        }, 0);
    }

    function initIframe() {
        iframeConfig.listenToIframeMessages($scope.iframeId);
        const eprocVersion = sessionStorage.getItem(STORAGE_KEY.EPROC_VERSION);
        const path = `client/order/${orderNumber}/prebook-receipt`;
        const iframeRoute = UriBuilder.parse(location.protocol + '//' + iframeConfig.iframeBase + path);
        iframeRoute.query.version = eprocVersion;
        iframeEl = angular.element(`#${$scope.iframeId}`);
        
        // Prüfe, ob das Element existiert
        if (iframeEl.length === 0 || !iframeEl[0]) {
            console.warn('Iframe element not found, retrying...', $scope.iframeId);
            $timeout(function() {
                initIframe();
            }, 100);
            return;
        }
        
        iframeEl[0].onload = () => {
            $scope.$apply();
        }

        iframeEl.attr('src', trustSrc(iframeRoute.toString()));
    }

    function handleDestroy() {
        iframeConfig.stopListeningToIframeMessages();
    }

    function trustSrc(src) {
        return $sce.trustAsResourceUrl(src);
    }

});

